import { AcornsIcon } from '@acorns/icons'
import { Card } from '@acorns/web-components'
import styled from 'styled-components'

import Button from 'components/Button'
import { Body, Heading2, Title } from 'components/Typography'
import { style } from 'theme'

export const SignYourCardContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
`

export const SignatureContainer = styled.div<{ mobileLandscape: boolean }>`
  height: 100%;
  width: 100%;
  border: ${props =>
    props.mobileLandscape ? 'none' : `2px dashed ${style(theme => theme.colors.ivory)}`};
  border-radius: 6px;
  margin: ${props => (props.mobileLandscape ? '0' : '40px auto 20px')};
`

export const TextContainer = styled.div<{ mobileLandscape: boolean }>`
  max-width: 400px;
  margin: 40px auto 0;
  text-align: center;
  display: ${props => (props.mobileLandscape ? 'none' : 'flex')};
  flex-direction: column;
`

export const PageTitle = styled(Heading2)`
  font-size: 22px;
  line-height: 30px;
  margin-bottom: 10px;
`

export const Subtitle = styled(Body)`
  margin: 0 auto;
  max-width: 450px;
`

export const TextToPhoneButton = styled(Button)`
  background: ${style(theme => theme.colors.ivoryLight)};
  color: ${style(theme => theme.colors.slate)};
  margin-bottom: 80px;
  min-width: 170px;
  border: none;
`

export const PhoneIcon = styled(AcornsIcon)`
  align-self: center;
  margin-right: 10px;
`

export const StyledButton = styled(Button)`
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    margin: 20px auto 0;
  }
`

export const HelperText = styled.p`
  font-size: 12px;
  text-align: center;
  margin: 10px auto 30px;
  font-style: italic;
  color: ${style(theme => theme.colors.stone)};
`

export const PhoneContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
`

export const SignaturePhoneContainer = styled(Card)`
  margin: 20px;
  width: calc(100% - 40px);
`

export const ModalTitle = styled(Title)`
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 600;
`

export const ModalBody = styled(Body)`
  margin-bottom: 48px;
  text-align: center;
  font-size: 14px;
`
